/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Builder_ForInputs */

const en_cp_builder_for = /** @type {(inputs: Cp_Builder_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student entrepreneurship grants (P2MW, PKM-K), campus incubators, would-be founders.`)
};

const id_cp_builder_for = /** @type {(inputs: Cp_Builder_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P2MW, PKM-K, Wirausaha Merdeka, inkubator kampus, calon founder.`)
};

/**
* | output |
* | --- |
* | "Student entrepreneurship grants (P2MW, PKM-K), campus incubators, would-be founders." |
*
* @param {Cp_Builder_ForInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_builder_for = /** @type {((inputs?: Cp_Builder_ForInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Builder_ForInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_builder_for(inputs)
	return en_cp_builder_for(inputs)
});